
  export const style={
    inpuStyle:{
      colorInput:"#34B78F"
    },
    url:{
      urlClient:"https://conecta.prd.appnoz.com.br/",
      urlClientYouseed:"https://admyouseed.bancosemear.com.br/"
    },
    fileUrl:{
      logo:"https://storage-client-profile.appnoz.com.br/base-api/uploads/logos/profile_client/logoclient/117/IMUNOBR_COR.png",
      secondaryLogonLogo: "null",
    },
    variables:{
       customMenuItem: true,
       autoRegister: false,
       recaptchaVersion : "V2"
    },
    CurrencyName:{
      name:"Imunocoin/Imunocoins"
    },
    teamName:{
      name:"imunobr"
    },
    hasToken: true,
    hostHeader: "imunobr"
  }
